import { render, staticRenderFns } from "./PainelVodal.vue?vue&type=template&id=13d8844e&"
import script from "./PainelVodal.vue?vue&type=script&lang=js&"
export * from "./PainelVodal.vue?vue&type=script&lang=js&"
import style0 from "./PainelVodal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports